import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

const TextField = ({ className = '', text }) => {
  const [DOMPurify, installDOMPurify] = useState({});

  useEffect(() => {
    import('dompurify').then(DOMPurifyModule => {
      installDOMPurify({ ...DOMPurifyModule.default });
    });
  }, []);

  if (!DOMPurify.sanitize) return null;

  return (
    <div
      className={cx('text-field', className)}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}
    />
  );
};

TextField.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
};

export default TextField;
